// suggestedReportsData.js
export const fetchIndustryData = () => {
    return new Promise((resolve) => {
        const data = [
            {
                id: "e-commerce",
                title: "E-Commerce",
                description: "Businesses that sell goods or services online.",
                subIndustries: [
                    { id: "fashion-apparel", name: "Fashion & Apparel" },
                    { id: "electronics-gadgets", name: "Electronics & Gadgets" },
                    { id: "home-furniture", name: "Home & Furniture" },
                    { id: "beauty-personal-care", name: "Beauty & Personal Care" },
                    { id: "food-grocery", name: "Food & Grocery" },
                    { id: "digital-products-services", name: "Digital Products & Services" },
                    { id: "others", name: "Others" },
                ],
            },
            {
                id: "healthcare",
                title: "Healthcare",
                description: "Healthcare providers and clinics focused on patient care.",
                subIndustries: [
                    { id: "hospitals-clinics", name: "Hospitals & Clinics" },
                    { id: "telemedicine", name: "Telemedicine" },
                    { id: "mental-health-services", name: "Mental Health Services" },
                    { id: "fitness-wellness", name: "Fitness & Wellness" },
                    { id: "medical-devices", name: "Medical Devices" },
                    { id: "pharmaceuticals", name: "Pharmaceuticals" },
                    { id: "others", name: "Others" },
                ],
            },
            {
                id: "financial-services",
                title: "Financial Services",
                description: "Banks, insurance companies, and financial advisory firms.",
                subIndustries: [
                    { id: "banking", name: "Banking" },
                    { id: "insurance", name: "Insurance" },
                    { id: "investment-management", name: "Investment Management" },
                    { id: "payments-transfers", name: "Payments & Transfers" },
                    { id: "personal-finance", name: "Personal Finance" },
                    { id: "cryptocurrency-blockchain", name: "Cryptocurrency & Blockchain" },
                    { id: "others", name: "Others" },
                ],
            },
            {
                id: "manufacturing",
                title: "Manufacturing",
                description: "Companies involved in the production of goods.",
                subIndustries: [
                    { id: "automotive", name: "Automotive" },
                    { id: "electronics-manufacturing", name: "Electronics Manufacturing" },
                    { id: "food-processing", name: "Food Processing" },
                    { id: "industrial-equipment", name: "Industrial Equipment" },
                    { id: "textile-manufacturing", name: "Textile Manufacturing" },
                    { id: "chemical-production", name: "Chemical Production" },
                    { id: "others", name: "Others" },
                ],
            },
            {
                id: "technology",
                title: "Technology",
                description: "Software, hardware, and IT services companies.",
                subIndustries: [
                    { id: "software-development", name: "Software Development" },
                    { id: "it-services-consulting", name: "IT Services & Consulting" },
                    { id: "cloud-computing", name: "Cloud Computing" },
                    { id: "artificial-intelligence", name: "Artificial Intelligence" },
                    { id: "cybersecurity", name: "Cybersecurity" },
                    { id: "hardware-devices", name: "Hardware & Devices" },
                    { id: "others", name: "Others" },
                ],
            },
            {
                id: "education",
                title: "Education",
                description: "Institutions and businesses providing educational services.",
                subIndustries: [
                    { id: "schools-universities", name: "Schools & Universities" },
                    { id: "online-learning", name: "Online Learning Platforms" },
                    { id: "corporate-training", name: "Corporate Training & Development" },
                    { id: "educational-software", name: "Educational Software" },
                    { id: "others", name: "Others" },
                ],
            },
            {
                id: "real-estate",
                title: "Real Estate",
                description: "Businesses involved in real estate development and sales.",
                subIndustries: [
                    { id: "residential-real-estate", name: "Residential Real Estate" },
                    { id: "commercial-real-estate", name: "Commercial Real Estate" },
                    { id: "property-management", name: "Property Management" },
                    { id: "real-estate-investment", name: "Real Estate Investment" },
                    { id: "others", name: "Others" },
                ],
            },
            {
                id: "hospitality",
                title: "Hospitality",
                description: "Hotels, restaurants, and tourism businesses.",
                subIndustries: [
                    { id: "hotels-resorts", name: "Hotels & Resorts" },
                    { id: "restaurants-cafes", name: "Restaurants & Cafes" },
                    { id: "travel-tourism", name: "Travel & Tourism" },
                    { id: "event-management", name: "Event Management" },
                    { id: "others", name: "Others" },
                ],
            },
            {
                id: "retail",
                title: "Retail",
                description: "Brick-and-mortar and online retail businesses.",
                subIndustries: [
                    { id: "grocery-stores", name: "Grocery Stores" },
                    { id: "department-stores", name: "Department Stores" },
                    { id: "luxury-goods", name: "Luxury Goods" },
                    { id: "convenience-stores", name: "Convenience Stores" },
                    { id: "others", name: "Others" },
                ],
            },
            {
                id: "transportation-logistics",
                title: "Transportation & Logistics",
                description:
                    "Businesses involved in transportation and supply chain management.",
                subIndustries: [
                    { id: "freight-logistics", name: "Freight & Logistics" },
                    { id: "public-transport", name: "Public Transport" },
                    { id: "ride-hailing", name: "Ride-Hailing Services" },
                    { id: "shipping", name: "Shipping" },
                    { id: "others", name: "Others" },
                ],
            },
            {
                id: "media-entertainment",
                title: "Media & Entertainment",
                description: "Businesses involved in content creation and entertainment.",
                subIndustries: [
                    { id: "film-tv", name: "Film & TV Production" },
                    { id: "music-industry", name: "Music Industry" },
                    { id: "gaming", name: "Gaming" },
                    { id: "publishing", name: "Publishing" },
                    { id: "others", name: "Others" },
                ],
            },
            {
                id: "agriculture",
                title: "Agriculture",
                description: "Farming and agribusiness companies.",
                subIndustries: [
                    { id: "crop-farming", name: "Crop Farming" },
                    { id: "livestock", name: "Livestock Farming" },
                    { id: "agriculture-technology", name: "Agriculture Technology" },
                    { id: "food-distribution", name: "Food Distribution" },
                    { id: "others", name: "Others" },
                ],
            },
            {
                id: "energy-utilities",
                title: "Energy & Utilities",
                description: "Businesses involved in energy production and distribution.",
                subIndustries: [
                    { id: "renewable-energy", name: "Renewable Energy" },
                    { id: "oil-gas", name: "Oil & Gas" },
                    { id: "electricity-providers", name: "Electricity Providers" },
                    { id: "water-utilities", name: "Water Utilities" },
                    { id: "others", name: "Others" },
                ],
            },
            {
                id: "others",
                title: "Others",
                description: "Industries that do not fit into any of the above categories.",
                subIndustries: [{ id: "others", name: "Others" }],
            },
        ];
        //
        resolve(data);
    });
};